import Box from '@mui/joy/Box'
import Tooltip from '@mui/joy/Tooltip'
import { DocumentPipelineDay } from '@numeo/types-core'

const SEGMENTS: { key: keyof Pick<DocumentPipelineDay, 'done' | 'notOfInterest' | 'combined' | 'failed' | 'inFlight'>; label: string; color: string }[] = [
    { key: 'done', label: 'Done', color: 'var(--joy-palette-success-400)' },
    { key: 'notOfInterest', label: 'Not of interest', color: 'var(--joy-palette-neutral-400)' },
    { key: 'combined', label: 'Several documents', color: 'var(--joy-palette-warning-400)' },
    { key: 'failed', label: 'Failed', color: 'var(--joy-palette-danger-400)' },
    { key: 'inFlight', label: 'In flight', color: 'var(--joy-palette-primary-300)' },
]

/** A day's outcomes as one stacked bar, sized by the day's share of the busiest day. */
export default function OutcomeBar({ day, max }: { day: DocumentPipelineDay; max: number }) {
    const width = max ? Math.max((day.enqueued / max) * 100, 2) : 0
    return (
        <Box sx={{ width: 160 }}>
            <Box sx={{ display: 'flex', width: `${width}%`, height: 10, borderRadius: 4, overflow: 'hidden' }}>
                {SEGMENTS.filter((s) => day[s.key] > 0).map((s) => (
                    <Tooltip key={s.key} title={`${s.label}: ${day[s.key]}`} size="sm">
                        <Box sx={{ flex: day[s.key], bgcolor: s.color }} />
                    </Tooltip>
                ))}
            </Box>
        </Box>
    )
}
